let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hhss7"), load("l5XQ1")]).then(() => parcelRequire('l9IRD'));